import React, {useState} from "react";
import {Button, message} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import TranslationFormModal from './translation-form-modal';

const NewTranslation = ({updateTranslation}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [translationKey, setTranslationKey] = useState('');
    const [translationValue, setTranslationValue] = useState('');

    const resetForm = () => {
        setTranslationKey('');
        setTranslationValue('');
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        if (translationKey) {
            updateTranslation(translationKey, translationValue);
            resetForm();
            message.success('Translation added!');
            setIsModalVisible(false);
        } else {
            message.error("Add translation key");
        }
    };

    const handleCancel = () => {
        resetForm();
        setIsModalVisible(false);
    };

    return (
        <>
            <Button className="add-translation-btn" type="primary" onClick={showModal}>
                <PlusOutlined/> Add new translation
            </Button>

            <TranslationFormModal
                open={isModalVisible}
                mode="add"
                draftKey={translationKey}
                draftValue={translationValue}
                onKeyChange={setTranslationKey}
                onValueChange={setTranslationValue}
                onSave={handleOk}
                onClose={handleCancel}
            />
        </>
    );
};

export default NewTranslation;
